import {Snackbar, styled} from '@mui/material';
import {StyledSnackbarProps} from './types';

export const StyledSnackbar = styled(Snackbar)<StyledSnackbarProps>`
	text-align: center;

	& .MuiSnackbarContent-root {
		justify-content: center;
		width: 100%;
		background-color: ${({$color}) => $color ?? 'default'};
	}

	${({theme}) => theme.breakpoints.up('md')} {
		width: 373px;
		right: 32px;
	}
`;
